"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));
var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _toggleBookmark = _interopRequireDefault(require("@micado-digital/react-bookmark/ReactBookmark/toggleBookmark"));
var _FallbackImage = _interopRequireDefault(require("@micado-digital/react-ui/components/FallbackImage"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _calculatePercentage = _interopRequireDefault(require("../../utils/calculatePercentage"));
var _Price = _interopRequireDefault(require("../Price"));
var _Tags = _interopRequireDefault(require("../Tags"));
var _ProductTeaser = _interopRequireDefault(require("./ProductTeaser.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProductTeaser = _ref => {
  let {
    displayedFeatures = [],
    lang,
    product,
    showAttributes,
    showBookmark
  } = _ref;
  const {
    attributes: _attributes = [],
    awardTag,
    awardTitle,
    combinationID = 0,
    description,
    features: _features = [],
    mediaList,
    pagename,
    // Because of different namings (list, detail)
    pageName,
    price,
    title
  } = product || {};
  const {
    amount,
    originalAmount,
    priceOption,
    scaleUnitAmount,
    scaleUnitTitle
  } = price || {};
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const css = (0, _ProductTeaser.default)();
  const tags = (0, _react.useMemo)(() => {
    let _tags = [];
    if (amount !== originalAmount) {
      _tags.push({
        color: "primary",
        tag: "discount",
        title: "".concat((0, _calculatePercentage.default)(amount, originalAmount), "%")
      });
    }
    if (awardTag && awardTitle) {
      _tags.push({
        color: "default",
        tag: awardTag,
        title: awardTitle
      });
    }
    return _tags;
  }, [amount, awardTag, awardTitle, originalAmount]);
  const link = (0, _react.useMemo)(() => {
    return "".concat(pageName !== null && pageName !== void 0 ? pageName : pagename).concat(combinationID ? "?combinationID=".concat(combinationID) : "");
  }, [combinationID, pageName, pagename]);
  const attributes = (0, _react.useMemo)(() => {
    var _attributes$map;
    return _attributes === null || _attributes === void 0 || (_attributes$map = _attributes.map(_ref2 => {
      let {
        title,
        value
      } = _ref2;
      return "<span>".concat(title, "</span>: ").concat(value);
    })) === null || _attributes$map === void 0 ? void 0 : _attributes$map.join(", ");
  }, [_attributes]);
  const features = (0, _react.useMemo)(() => {
    var _features$filter;
    return _features === null || _features === void 0 || (_features$filter = _features.filter(_ref3 => {
      let {
        identifier
      } = _ref3;
      return displayedFeatures.indexOf(identifier) > -1;
    })) === null || _features$filter === void 0 || (_features$filter = _features$filter.map(_ref4 => {
      let {
        title,
        value
      } = _ref4;
      return "<span>".concat(title, "</span>: ").concat(value);
    })) === null || _features$filter === void 0 ? void 0 : _features$filter.join(", ");
  }, [_features, displayedFeatures]);
  const handleAddToBookmark = () => {
    var _shopData$currency, _product$price, _product$price2;
    (0, _fireCustomEvent.default)("add_to_wishlist", {
      ecommerce: {
        currency: shopData === null || shopData === void 0 || (_shopData$currency = shopData.currency) === null || _shopData$currency === void 0 ? void 0 : _shopData$currency.isoCode,
        value: product === null || product === void 0 || (_product$price = product.price) === null || _product$price === void 0 ? void 0 : _product$price.amount,
        items: [{
          item_name: product === null || product === void 0 ? void 0 : product.title,
          item_variant: product === null || product === void 0 ? void 0 : product.combinationID,
          price: product === null || product === void 0 || (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : _product$price2.amount
        }]
      }
    });
  };
  const handleClick = () => {
    var _product$price3;
    (0, _fireCustomEvent.default)("select_item", {
      ecommerce: {
        items: [{
          item_name: product === null || product === void 0 ? void 0 : product.title,
          item_variant: product === null || product === void 0 ? void 0 : product.combinationID,
          price: product === null || product === void 0 || (_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : _product$price3.amount
        }]
      }
    });
  };
  const handleRemoveFromBookmark = () => {
    var _shopData$currency2, _product$price4, _product$price5;
    (0, _fireCustomEvent.default)("remove_from_wishlist", {
      ecommerce: {
        currency: shopData === null || shopData === void 0 || (_shopData$currency2 = shopData.currency) === null || _shopData$currency2 === void 0 ? void 0 : _shopData$currency2.isoCode,
        value: product === null || product === void 0 || (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : _product$price4.amount,
        items: [{
          item_name: product === null || product === void 0 ? void 0 : product.title,
          item_variant: product === null || product === void 0 ? void 0 : product.combinationID,
          price: product === null || product === void 0 || (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : _product$price5.amount
        }]
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
    className: (0, _clsx.default)(css.productTeaser, "mco-shop-product-teaser"),
    to: link,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.image, "mco-shop-product-teaser__image-wrapper")
  }, !(0, _isEmpty.default)(mediaList) ? /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, {
    media: mediaList === null || mediaList === void 0 ? void 0 : mediaList[0],
    mediaFormats: {
      xs: "product-teaser"
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.fallbackImage, "mco-shop-product-teaser__fallback-image")
  }, /*#__PURE__*/_react.default.createElement(_FallbackImage.default, null)), !(0, _isEmpty.default)(tags) && /*#__PURE__*/_react.default.createElement(_Tags.default, {
    classNames: css.tags,
    tags: tags
  }), showBookmark && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.bookmark, "mco-shop-product-teaser__bookmark")
  }, /*#__PURE__*/_react.default.createElement(_toggleBookmark.default, {
    componentBookmarked: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentBookmarkedHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentDefault: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark.svg",
      size: 24
    }),
    componentHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    data: {
      ...product,
      combinationID
    },
    validationFields: ["id", "combinationID", "objectType"],
    onAdded: handleAddToBookmark,
    onRemoved: handleRemoveFromBookmark
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-product-teaser__content")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.title, "mco-shop-product-teaser__title"),
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), description && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.description, "mco-shop-product-teaser__description"),
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), (!(0, _isEmpty.default)(features) || !(0, _isEmpty.default)(attributes)) && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.attributes, "mco-shop-product-teaser__attributes"),
    dangerouslySetInnerHTML: {
      __html: "".concat(!(0, _isEmpty.default)(features) ? features : "", " ").concat(!(0, _isEmpty.default)(features) && showAttributes && !(0, _isEmpty.default)(attributes) ? " - " : "", " ").concat(showAttributes && !(0, _isEmpty.default)(attributes) ? attributes : "")
    }
  }), /*#__PURE__*/_react.default.createElement(_Price.default, {
    classNames: css.price,
    amount: amount,
    lang: lang,
    originalAmount: originalAmount,
    priceOption: priceOption,
    scaleUnitAmount: scaleUnitAmount,
    scaleUnitTitle: scaleUnitTitle
  })));
};
var _default = exports.default = ProductTeaser;